module.exports = __webpack_public_path__ + "fade127f8b8988f6ab54467b0936888f.pdf";